<template>
  <div>
    <div class="box">
      <div class="wave -one"></div>
      <div class="wave -two"></div>
      <div class="wave -three"></div>
    </div>
    <titleBar></titleBar>
    <div class="routerSheet">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import titleBar from "@/theme/components/titleBar/component";
export default {
  data: () => ({}),
  components: {
    titleBar
  },
  methods: {}
};
</script>

<style scoped lang="sass">
.routerSheet
  position: fixed
  margin-top: map-deep-get($titleBar, "height")
  overflow-y: auto
  width: 100%
  height: calc(100vh - #{map-deep-get($titleBar, "height")})
  max-height: calc(100vh - #{map-deep-get($titleBar, "height")})
</style>

<style scoped lang="sass">
#app
  background: linear-gradient(45deg,#F17C58, #E94584, #24AADB)
  background-size: 600% 100%
  animation: gradient 16s linear infinite
  animation-direction: alternate
@keyframes gradient
  0%
    background-position: 0%

  100%
    background-position: 100%
.box
  position: fixed
  top: 0
  transform: rotate(75deg)
  left: 0
  &:after
    content: ''
    display: block
    left: 0
    top: 0
    width: 100%
    height: 100%
    z-index: 11
    transform: translate3d(0, 0, 0)
.wave
  position: absolute
  top: 3%
  left: 10%
  opacity: .4
  background: rgba(200, 200, 200, 0.4)
  width: 1500px
  height: 1500px
  margin-left: -600px
  margin-top: -150px
  transform-origin: 50% 48%
  border-radius: 45%
  animation: drift 7000ms infinite linear
  &.-three
    animation: drift 7500ms infinite linear
    position: fixed
    box-shadow: 3px 3px 5px 6px rgba(200, 200, 200, 1)
    background: linear-gradient(45deg,#24AADB, #F17C58, #E94584)
  &.-two
    animation: drift 3000ms infinite linear
    opacity: .1
    background: black
    position: fixed
@keyframes drift
  from
    transform: rotate(0deg)
  from
    transform: rotate(360deg)
</style>
